import { Menu } from 'antd';
import React from 'react';
import SEARCH_DARK from 'assets/img/black/search.svg';
import ARROW from 'assets/img/play_arrow.svg';
import ARROW_BLUE from 'assets/img/play_arrow_blue.svg';
import SEARCH from 'assets/img/search.svg';
import { CustomIcon, Input, SpeedSlider } from '../../../../common';
import { SwitchBlock, TagBlock } from '../index';
import './style.scss';

export const ProjectOptions = ({ openAddProvidersPopup, isDarkTheme }) => (
  <div className="project_options">
    <div className="project_options_row project_add_provider">
      <h3 className="project_options_title">Providers</h3>
      <div className="project_add_provider_input">
        <Input
          style={{ height: '32px', boxShadow: 'none', marginBottom: 0 }}
          iconSrc={isDarkTheme ? SEARCH_DARK : SEARCH}
          inputProps={{
            placeholder: 'Search',
          }}
        />
      </div>
    </div>
    <Menu mode="inline" inlineIndent={0}>
      <div className="project_options_provider">
        <SwitchBlock title="Carriers" />
        <SwitchBlock title="Resellers" />
      </div>
      <div className="project_options_provider_column" style={{ marginBottom: '15px' }}>
        <SwitchBlock title="AT&T" />
        <SwitchBlock title="Atlantic Broadband" />
        <SwitchBlock title="Nitel" />
        <SwitchBlock title="Sprint" />
      </div>
      <span style={{ marginTop: '15px', cursor: 'pointer' }} onClick={() => openAddProvidersPopup()}>
        <CustomIcon src={isDarkTheme ? ARROW_BLUE : ARROW} width="8px" height="10px" rotate="270" />See All Providers
      </span>
    </Menu>
    <div className="project_options_row">
      <h3 className="project_options_title">Confidence</h3>
    </div>
    <TagBlock />
    <div className="project_options_row">
      <h3 className="project_options_title">Speed</h3>
    </div>
    <div className="project_options_speed_slider">
      <SpeedSlider isDarkTheme={isDarkTheme} />
    </div>
    <div className="project_options_row">
      <h3 className="project_options_title">Technology</h3>
    </div>
    <div className="project_options_provider_column">
      <SwitchBlock title="Fiber" />
      <SwitchBlock title="BroadBand" />
      <SwitchBlock title="Mobile" />
    </div>
    <div className="project_options_row">
      <h3 className="project_options_title">On-Net / Off-Net </h3>
    </div>
    <div className="project_options_provider_column">
      <SwitchBlock title="On-Net" />
      <SwitchBlock title="Off-Net" />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/ProjectOptions/index.js